import { useEffect, useState } from "react";
import { endPoints, getData } from "../utilities/networkCalls";

const states = {
    enabled: 1,
    disabled: 0,
    loading: -1,
};

const useSnippet = () => {
    const [isEnabled, setIsEnabled] = useState(states.loading);

    useEffect(() => {
        const checkExtension = async () => {
            if (document.visibilityState === "visible") {
                shopify.loading(true);
                const res = await getData({ url: endPoints.extensionStatus });
                shopify.loading(false);
                if (res.status === 200) {
                    if (res.data.status === 1) {
                        setIsEnabled(states.enabled);
                    } else {
                        setIsEnabled(states.disabled);
                    }
                } else {
                    setIsEnabled(states.disabled);
                }
            }
        };
        checkExtension();
        document.addEventListener("visibilitychange", checkExtension);

        return () => {
            document.removeEventListener("visibilitychange", checkExtension);
        };
    }, []);

    console._log(isEnabled);

    return { isEnabled };
};

export default useSnippet;
